import React from 'react'
import { Button, Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap'
import { Clock as IconClock, CheckCircle as IconCheck } from 'react-feather'
import { Col, Row, Show } from '~/components/commons'
import Spinner from '~/components/@vuexy/spinner/Loading-spinner'

import { FormattedMessage, useIntl } from 'react-intl'
import { format } from 'date-fns'
import { ptBR, enUS } from 'date-fns/locale'
import _ from 'lodash'

const ContentLabel = ({ children }) => (
  <Col md={12} style={{ marginBottom: '20px' }}>
    <IconCheck size={24} color="#3d9244" />
    <label
      style={{
        color: '#000',
        fontFamily: 'Montserrat',
        marginLeft: '15px',
        fontSize: '16px',
        fontWeight: 500,
        paddingRight: '5px',
      }}
    >
      {children}
    </label>
  </Col>
)

const ContentInfo = ({ url, altName }) => (
  <Col md={12} style={{ marginBottom: '20px' }}>
    <img
      style={{ maxWidth: '100%', paddingRight: '10px' }}
      src={url}
      alt={altName}
    />
  </Col>
)

function PreviewImages({
  images = {},
  toggleModal,
  isOpen,
  onSubmit,
  isSubmiting,
  isValid,
  scheduleEdition,
}) {
  const intl = useIntl()

  return (
    <>
      <Modal isOpen={isOpen} toggle={toggleModal} className="modal-lg">
        <ModalHeader toggle={toggleModal} style={{ paddingLeft: '25px' }}>
          <FormattedMessage id="Updated informations" />
        </ModalHeader>
        <ModalBody
          className="modal-dialog-centered"
          style={{ alignItems: 'stretch', padding: '25px' }}
        >
          <Row className="w-100 overflow-auto" style={{ maxHeight: '650px' }}>
            <Show condition={isSubmiting}>
              <Spinner />
            </Show>
            {['logo', 'cover', 'interior', 'exterior', 'additional'].map(
              (imageType, i) => (
                <Show
                  key={`${imageType}-imgs-${i}`}
                  condition={images[imageType]?.length}
                >
                  <ContentLabel key={`${imageType}-imgs-${i}`}>
                    <FormattedMessage id={_.capitalize(imageType)} />:
                  </ContentLabel>
                  {images[imageType]?.map((image, i) => (
                    <Col md={4} key={`${imageType}-imgs-${i}`}>
                      <ContentInfo
                        url={image?.uri}
                        altName={`${imageType} image`}
                      />
                    </Col>
                  ))}
                </Show>
              )
            )}
          </Row>
        </ModalBody>
        <ModalFooter
          className="d-flex justify-content-between"
          style={{ padding: '20px' }}
        >
          <div className="d-flex align-items-center">
            <IconClock size={33} className="mr-1" />
            <div>
              <h4 className="mb-0">
                <FormattedMessage id="Published at" />:
              </h4>
              <p className="mb-0">
                {!scheduleEdition ? (
                  <FormattedMessage id="Now" />
                ) : (
                  format(scheduleEdition, 'Pp', {
                    locale: intl.locale === 'br' ? ptBR : enUS,
                  })
                )}
              </p>
            </div>
          </div>
          <div className="d-flex">
            <Button
              outline
              color="primary"
              onClick={() => toggleModal(false)}
              disabled={isSubmiting}
            >
              <FormattedMessage id="Edit" />
            </Button>
            <Button
              color={scheduleEdition ? 'info' : 'success'}
              className="ml-2"
              onClick={onSubmit}
              disabled={isSubmiting || !isValid}
            >
              <FormattedMessage
                id={`Confirm & ${scheduleEdition ? 'Schedule' : 'Update'}`}
              />
            </Button>
          </div>
        </ModalFooter>
      </Modal>
    </>
  )
}

export default PreviewImages
